import { Fragment, useEffect, useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';

import { SendEmailService } from '../../../service/invoice/SendEmailService';

import { ToastService } from '../../../AppToast';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';

import { DialogSentEmail } from './DialogSentEmail';
import { TenantSettingService } from '../../he-thong/tham-so-he-thong/TenantSettingService';
import { useTranslation } from '../../../shared/language';

export const DialogSendEmail = (props) => {
  const { t } = useTranslation();

  const { display, setDisplay, selectedItems, sendType } = props;

  const [submitting, setSubmitting] = useState(null);
  const [toEmail, setToEmail] = useState('');
  const [notiPayment, setNotiPayment] = useState(false);

  const { render: renderDialogCrup, view } = useDialogCrup({
    header: '',
    width: '80rem',
    fields: [
      { field: 'sender', header: t('common.senderEmail'), required: true, type: 'email', InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'displayName', header: t('common.alias'), required: true, InputTextProps: { maxLength: 250 }, className: 'md:col-6' },
      { field: 'toEmails', header: t('common.customerEmail'), required: true, InputTextProps: { maxLength: 100 }, className: 'md:col-12' },
      { field: 'subject', header: t('common.subject'), required: true, InputTextProps: { maxLength: 100 }, className: 'md:col-12' },
      { field: 'body', header: '', required: true, type: 'CKEditor', className: 'md:col-12' }
    ]
  });

  const getData = (skipValidate?: boolean) => {
    if (toEmail) {
      const toEmailArray = toEmail.replace(';', ',').split(',');
      let valid = true;
      const toEmails = [];
      toEmailArray.forEach((email, index) => {
        const _email = email.trim();
        if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(_email.trim())) {
          toEmails.push(_email);
        } else {
          valid = false;
          ToastService.error(t('common.emailInvalidAtIndex', { index: index + 1 }));
        }
      });
      if (valid) {
        let invoices;
        if (Array.isArray(selectedItems)) {
          invoices = selectedItems.map((item) => ({ id: item.id || item.invoiceId, email: item.buyerEmail, invoiceSerial: item.invoiceSerial, sendTaxStatus: item.sendTaxStatus }));
        } else {
          invoices = [{
            id: selectedItems['id'] || selectedItems['invoiceId'],
            email: selectedItems['buyerEmail'],
            invoiceSerial: selectedItems['invoiceSerial'],
            sendTaxStatus: selectedItems['sendTaxStatus'],
          }];
        }
        return {
          invoices,
          sendType: sendType,
          toEmails
        };
      }
    } else {
      let invoices;
      if (Array.isArray(selectedItems)) {
        invoices = selectedItems.map((item) => ({ id: item.id || item.invoiceId, email: item.buyerEmail, invoiceSerial: item.invoiceSerial, sendTaxStatus: item.sendTaxStatus }));
      } else {
        invoices = [{
          id: selectedItems['id'] || selectedItems['invoiceId'],
          email: selectedItems['buyerEmail'],
          invoiceSerial: selectedItems['invoiceSerial'],
          sendTaxStatus: selectedItems['sendTaxStatus'],
        }];
      }
      return {
        invoices,
        sendType: sendType,
        toEmails: []
      };
    }
  }

  const viewBeforeSend = () => {
    const data = getData(true);
    if (data && !submitting) {
      setSubmitting(true);
      SendEmailService.viewBeforeSend(data).then(email => {
        if (email) {
          email.toEmails = email.toEmails ? email.toEmails.join(',') : email.toEmails;
          view(email);
        }
        setSubmitting(false);
      });
    }
  }
  const onShow = () => {
    setToEmail('');
  }
  const handleSubmit = (type: string = 'email') => {

    const data = getData();

    if (data && !submitting) {
      setSubmitting(true);

      if (type === 'payment') {
        SendEmailService.payment(data).then(result => {
          if (result.hasError) {
            ToastService.error(result.error);
          } else {
            ToastService.success();
          }
          setSubmitting(false);
          setDisplay(false);
        });
        return;
      }

      SendEmailService.invoice(data).then(result => {
        if (result.hasError) {
          let message = result.emailError;
          if (result.emailError == null || result.emailError == undefined) {
            message = result.error;
          }
          ToastService.error(message);
        } else {
          ToastService.success();
        }
        setSubmitting(false);
        setDisplay(false);
      });
    }
  }

  useEffect(() => {
    TenantSettingService.getList({
      key: TenantSettingService.key.THANH_TOAN_QRCODE_HOA_DON,
    }).then(res => {
      if (res.items.length > 0) {
        setNotiPayment(res.items[0].value === "C");
      }
    })
  }, []);

  return (
    <Fragment>
      <Dialog header={t('common.sendEmail')} visible={display} style={{ width: '60rem' }} draggable={false} resizable={true} position="top"
        onHide={() => setDisplay(false)} onShow={onShow}>
        <div className="grid">
          <div className="col-12">
            <div className="p-fluid p-3">
              <div className="field mb-0">
                <label htmlFor="toEmail">{t('common.enterCustomerEmail')}</label>
                <InputTextarea id="toEmail" placeholder={t('common.emailFallback')} value={toEmail} onChange={e => setToEmail(e.target.value)} autoResize />
              </div>
              <div className="field grid">
                <div className="col-12 md:col-12">
                  <i>{t('common.emailSeparator')}</i>
                </div>
              </div>
              {(selectedItems && (selectedItems['id'] || selectedItems['invoiceId'])) &&
                <DialogSentEmail selectedItem={selectedItems} />
              }
              <div className="field grid">
                <div className="col-12 md:col-12">
                  <b className="p-link" onClick={viewBeforeSend}>{t('common.reviewEmail')}</b>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-content-end gap-2">
          <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm" />
          <Button label={t('common.sendEmail')} icon="pi pi-send" onClick={() => handleSubmit('email')} loading={submitting} className="p-button-sm" />
          {notiPayment && selectedItems && !selectedItems?.isPaymented && selectedItems?.sendTaxStatus === 4 && <Button label={t('common.paymentNotification')} icon="pi pi-money-bill" onClick={() => handleSubmit('payment')} loading={submitting} className="p-button-sm" />}
        </div>
      </Dialog>
      {renderDialogCrup()}
    </Fragment>
  );
}
